var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C14.8638 0 16.43 1.27477 16.874 3H22C23.1046 3 24 3.89543 24 5V9.32324C23.9999 10.0265 23.6268 10.6907 23 11.0381V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V11.0381C0.373207 10.6907 9.7036e-05 10.0265 0 9.32324V5C1.61064e-08 3.89543 0.895431 3 2 3H7.12598C7.57002 1.27477 9.13616 0 11 0H13ZM3 18H21V11.7021C19.2574 12.1925 16.6847 12.769 13.7617 12.9453C13.4243 13.5729 12.7624 14 12 14C11.2369 14 10.5735 13.5727 10.2363 12.9443C7.31379 12.7678 4.74213 12.1897 3 11.6992V18ZM2 9.29883C3.31751 9.75002 6.50057 10.7084 10.3018 10.9453C10.6547 10.3781 11.2828 10 12 10C12.717 10 13.3442 10.3784 13.6973 10.9453C17.4989 10.7085 20.6824 9.75006 22 9.29883V5H2V9.29883ZM11 2C10.2601 2 9.61546 2.40267 9.26953 3H14.7305C14.3845 2.40267 13.7399 2 13 2H11Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.56a1f3b66d6f2a5dd23cd63486aada60.svg";
export { ForwardRef as ReactComponent };